import createIcon from '../../createIcon';

/**
 * @component @name IosShare
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNUwxNC41OCA2LjQyTDEyLjk5IDQuODNWMTZIMTEuMDFWNC44M0w5LjQyIDYuNDJMOCA1TDEyIDFMMTYgNVpNMjAgMTBWMjFDMjAgMjIuMSAxOS4xIDIzIDE4IDIzSDZDNC44OSAyMyA0IDIyLjEgNCAyMVYxMEM0IDguODkgNC44OSA4IDYgOEg5VjEwSDZWMjFIMThWMTBIMTVWOEgxOEMxOS4xIDggMjAgOC44OSAyMCAxMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const IosShare = createIcon('IosShare', [
  [
    'path',
    {
      d: 'M16 5L14.58 6.42L12.99 4.83V16H11.01V4.83L9.42 6.42L8 5L12 1L16 5ZM20 10V21C20 22.1 19.1 23 18 23H6C4.89 23 4 22.1 4 21V10C4 8.89 4.89 8 6 8H9V10H6V21H18V10H15V8H18C19.1 8 20 8.89 20 10Z',
      key: '1q8mrk',
    },
  ],
]);

export default IosShare;
